var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLxnavLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.1763in",
    height: "1.0287in",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 8067.7 2612.8",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-125.85 -78.655)",
    clipRule: "evenodd",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "m8159.7 2021.3v-1272.5s0-636.31-636.27-636.31h-4120.5l-310.53 461.59-306.81-461.59h-1989.6s-636.29 0-636.29 636.31v1272.5s0 636.26 636.29 636.26h6727.4s636.27 0 636.27-636.26z",
    fill: "none",
    imageRendering: "optimizeQuality",
    stroke: "#fff",
    strokeWidth: 67.73
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m1736.8 742.42h389.16l108.1 435.49 281.07-435.49h326.94l-1009.7 1497-31.91 47.28h-335.42l525.05-778.35-142.09-491.07h-160.58zm1354.6 1915.2 1.04-2083.5-306.81-461.59h-1989.6s-636.29 0-636.29 636.31v1272.5s0 636.26 636.29 636.26zm-964.77-748.79 239.29-354.69 133.84 457.68h160.56l-49.41 274.92h-389.15zm-1130.7-1549.1h512.72l-303 1652.1h160.62l-49.41 274.88h-512.75l303.02-1652.1h-160.56z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m3713.4 1174.8-194.55 1111.9h352.05l191.51-1087.2 80.26-77.21c77.22-74.12 126.65-101.96 169.87-101.96 49.43 0 67.98 33.99 49.43 145.18l-197.66 1121.1h512.72l49.41-274.88h-160.61l148.27-846.26c49.41-281.06 12.34-453.98-222.37-453.98-111.21 0-228.54 52.48-345.92 148.23l-71.05 58.67c-21.65-89.56-61.76-148.23-105-176.02h-213.11c9.25 98.81-15.43 277.92-43.25 432.36z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5541.8 711.54c-231.62 0-395.37 185.31-503.46 803.03-108.07 617.67 12.34 802.98 243.98 802.98 111.2 0 237.84-80.27 355.21-182.21 18.52 74.11 55.6 126.64 95.74 151.33h339.75l49.41-274.88h-160.62l145.2-836.97c27.77-154.42 71-333.58 111.16-432.39h-213.12c-46.33 24.68-101.9 77.22-148.23 151.33-83.4-101.91-203.86-182.22-315.02-182.22zm-120.47 1312.6c-64.87 0-117.38-15.43-30.88-509.56 86.46-494.17 145.13-509.62 210.01-509.62 40.16 0 77.23 15.45 123.56 83.36l37.07 52.53-129.72 735.07-55.58 52.52c-74.19 67.93-114.3 95.7-154.46 95.7z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m6456 742.44 101.91 1544.2h330.5l645.52-1544.2h-324.32l-237.8 614.62c-74.15 185.27-154.41 444.74-154.41 444.74s6.17-259.47 0-444.74l-21.65-614.62z",
    imageRendering: "optimizeQuality"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLxnavLogoLight);
export default __webpack_public_path__ + "static/media/lxnav_logo_light.d133534e812e5dd8d70c6118c7641870.svg";
export { ForwardRef as ReactComponent };